var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"player",staticClass:"simplecast-player simplecast-player-legacy",class:( _obj = {}, _obj[_vm.size] = _vm.size, _obj['dark'] =  _vm.dark, _obj ),style:(_vm.artworkStyle)},[_c('Main',{attrs:{"dark":_vm.dark,"size":_vm.size,"store":_vm.store}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }